function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(.008)",
  d: "M30.383,63.965A31.512,31.512,0,0,1,9.3,54.625a32.169,32.169,0,0,1,0-45.258A31.567,31.567,0,0,1,50.563,6.227,31.576,31.576,0,0,1,91.82,9.367a32.212,32.212,0,0,1,0,45.258A31.621,31.621,0,0,1,50.547,57.77,31.558,31.558,0,0,1,31.75,64C31.289,64,30.828,63.98,30.383,63.965ZM18.734,18.887a18.66,18.66,0,0,0,0,26.223,18.093,18.093,0,0,0,21.875,3.145l-9.82-9.895a6.776,6.776,0,0,1,0-9.516,6.63,6.63,0,0,1,9.445,0L56.367,45.109a18.305,18.305,0,0,0,26.016,0,18.669,18.669,0,0,0,0-26.223,18.156,18.156,0,0,0-21.875-3.133l9.813,9.9a6.733,6.733,0,0,1,0,9.516,6.649,6.649,0,0,1-9.437,0L44.75,18.887a18.3,18.3,0,0,0-26.016,0Z",
  fill: "currentColor"
});

function SvgInfinityArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 101.12 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityArrow);
export default __webpack_public_path__ + "static/media/infinity-arrow.dce37985.svg";
export { ForwardRef as ReactComponent };